/* global gtag */
import * as React from "react";
import { useState, useRef, useEffect, lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkExisting,
  setActionType,
  setGeneratedNeedId,
  setIsChatModalOpen,
  setIsZoomStarted,
  setLink,
  setInquiryOpen,
  setShowCallDialog,
} from "../../../../redux/slices/SearchBarSlice";
import {
  setDropdownOpen,
  setIsModalOpen,
} from "../../../../redux/slices/bwvSlice";
import { userAction } from "../../../../redux/slices/userSlice";
import { toast } from "react-toastify";
import { getAllMessages, sendMessage } from "../../Data";
import { useSocket } from "../../../../contexts/SocketContext";
import axiosClient from "../../../../axios-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import InquiryForm from "./InquiryForm";
import { FaWindowClose } from "react-icons/fa";
import "./Inquiry.css";
import {
  resetInquiryState,
  SendInquiry,
  setEnquiryStep,
  setDescription,
  setServiceId,
} from "../../../../redux/slices/InquirySlice";

// Lazy-load utilities
const loadUtilities = async () => {
  const { default: axiosClient } = await import("../../../../axios-client");
  const {
    makeCall,
    postRequest,
    sendMsgMail,
    virtualTourClick,
    postOtherVendors,
  } = await import("../../Data");
  const { GetZoomLink } = await import("../../Data2");
  return {
    axiosClient,
    makeCall,
    postRequest,
    postOtherVendors,
    sendMsgMail,
    virtualTourClick,
    GetZoomLink,
    toast,
  };
};

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const InquiryModal = () => {
  const { selectedConvo } = useSelector((state) => state.messages);
  const islogin = useSelector((state) => state.user.isLogin);
  const userData = useSelector(
    (state) => state.user.userDetails.profileDetails
  );
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const {
    inquiryOpen,
    sampleAd,
    actionType,
    checkExistingError,
    checkExistingStatus,
    vTName,
    vTNumber,
    answers,
  } = useSelector((state) => state.searchBar);
  const { sendNewMessage } = useSocket();
  const { dropdownOpen } = useSelector((state) => state.bwvData);
  const { searchQuery } = useSelector((state) => state.lcAds);
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.inquiry);
  const { otherVendors, enquiryStep } = useSelector((state) => state.inquiry);
  const [isLoading, setIsLoading] = useState(false);
  // const [descriptionError, setDescriptionError] = useState(false);
  const [eventDetailsError, setEventDetailsError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [secondaryPhoneError, setSecondaryPhoneError] = useState(false);
  const [zipcodeError, setZipcodeError] = useState(false);
  const [countryCodeError, setCountryCodeError] = useState(false);
  const [mandatoryQuestionsError, setMandatoryQuestionsError] = useState(false);
  const [otherVendorsError, setOtherVendorsError] = useState(false);
  const { bwvSearchQuery } = useSelector((state) => state.bwvData);
  const [receivedOtp, setReceivedOtp] = useState(null);
  const isProd = process.env.REACT_APP_PRODUCTION === "true";
  const firstInputRef = useRef(null);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+1");
  const [signUpData, setSignUpData] = useState(null);
  const isAdmin = user && user.Role === "admin";
  const isVendor = user?.Role === "provider";
  const [guestUserData, setGuestUserData] = useState(null);
  const handleClose = () => {
    dispatch(setInquiryOpen(false));
    dispatch(resetInquiryState());
    dispatch(setDescription(""));
    // setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    dispatch(setEnquiryStep(1));
    dispatch(setShowCallDialog(false));
  };
  const validateEventDetails = (eventDetails) => {
    if (!eventDetails) return false;
    console.log(eventDetails, "eventDetails");
    try {
      const event = JSON.parse(eventDetails)[0];
      return (
        event.eventDate &&
        event.eventTime &&
        event.eventType &&
        event.eventLocation &&
        event.totalGuestCount &&
        event.eventDate.trim() !== "" &&
        event.eventTime.trim() !== "" &&
        event.eventType.trim() !== "" &&
        event.eventLocation.trim() !== "" &&
        event.totalGuestCount.trim() !== ""
      );
    } catch (error) {
      console.error("Error parsing eventDetails:", error);
      return false;
    }
  };
  const validateMandatoryQuestions = () => {
    if (!sampleAd?.Questions) return true;
    try {
      const parsedQuestions = JSON.parse(sampleAd.Questions);
      console.log(parsedQuestions, "Questions");
      console.log(answers, "Questions-answers");
      return parsedQuestions.every((question) => {
        if (!question.mandatory) return true;
        const answer = answers[question.label];
        if (question.type === "text") {
          return !!answer && answer.trim() !== "";
        }
        if (question.type === "options") {
          return !!answer && answer !== "";
        }
        if (question.type === "check") {
          if (Array.isArray(answer)) {
            return answer.length > 0;
          }
          return answer === true; // for single boolean checkboxes
        }
        return true;
      });
      // return parsedQuestions.every((question) => {
      //   if (!question.mandatory) return true;
      //   const answer = answers[question.label];
      //   if (question.type === "text" && (!answer || answer.trim() === "")) {
      //     return false;
      //   }
      //   if (question.type === "options" && (!answer || answer === "")) {
      //     return false;
      //   }
      //   if (question.type === "check" && answer !== true) {
      //     return false;
      //   }
      //   return true;
      // });
    } catch (error) {
      console.error(
        "Failed to parse sampleAd.Questions for validation:",
        error
      );
      return true;
    }
  };
  const validateForm = () => {
    let isValid = true;
    if (enquiryStep == 1) {
      if (!islogin && !formData.Email) {
        setEmailError(true);
        // toast.error("Email is required");
        isValid = false;
      }
      if (!formData.Zipcode || !/^\d{5}$/.test(formData.Zipcode)) {
        setZipcodeError(true);
        // toast.error("Valid 5-digit zipcode is required");
        isValid = false;
      }
      if (!formData.Phone || formData.Phone.length !== 10) {
        setPhoneError(true);
        // toast.error("Valid 10-digit phone number is required");
        isValid = false;
      }
      if (
        formData.alternativePhoneOne &&
        formData.alternativePhoneOne.length !== 10
      ) {
        setSecondaryPhoneError(true);
        // toast.error("Valid 10-digit secondary phone number is required");
        isValid = false;
      }
      if (formData.alternativePhoneOne === formData.Phone) {
        setSecondaryPhoneError(true);
        // toast.error(
        //   "Secondary phone number should be different from primary phone number"
        // );
        isValid = false;
      }
      if (!selectedCountry) {
        setCountryCodeError(true);
        // toast.error("Please select a country code");
        isValid = false;
      }
    }
    if (enquiryStep == 2) {
      const isEventDetailsValid = validateEventDetails(formData.eventDetails);
      if (!isEventDetailsValid) {
        setEventDetailsError(true);
        toast.error("Please fill in all event details");
        isValid = false;
      }
    }
    if (enquiryStep == 3) {
      const isMandatoryQuestionsValid = validateMandatoryQuestions();
      if (!isMandatoryQuestionsValid) {
        setMandatoryQuestionsError(true);
        toast.error("Please answer all mandatory questions");
        isValid = false;
      }
      // if (!formData?.Description || formData?.Description.trim() === "") {
      //   setDescriptionError(true);
      //   toast.error("Description is required");
      //   isValid = false;
      // }
    }
    if (enquiryStep == 4) {
      if (!formData.noOtherVendors) {
        if (formData.otherVendors.length === 0) {
          setOtherVendorsError(true);
          toast.error(
            "Please select at least one vendor or check 'I don't need other vendors.'"
          );
          isValid = false;
        }
      }
    }
    return isValid;
  };
  useEffect(() => {
    dispatch(setServiceId(sampleAd?.Id || sampleAd?.id || sampleAd?.post_id));
    if (inquiryOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [inquiryOpen, enquiryStep, sampleAd]);
  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };
  useEffect(() => {
    if (checkExistingStatus === "failed" && checkExistingError) {
      toast.error(checkExistingError);
    }
  }, [checkExistingStatus, checkExistingError]);
  console.log(formData, "formData-inquiry");
  console.log(sampleAd, "sampleAd-inquiry");
  console.log(signUpData, "signUpData-inquiry");
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  };
  const handleStartZoomCall = async () => {
    const { toast, makeCall, GetZoomLink, sendMsgMail, virtualTourClick } =
      await loadUtilities();
    if (!islogin && !vTName) {
      toast.error("Please Enter Email");
      return;
    }
    if (!islogin && !vTNumber) {
      toast.error("Please Enter Phone Number");
      return;
    }
    const serviceInfo = JSON.parse(sampleAd?.additionalPeople || "[]");
    const newPerson1 = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
    };
    let newPerson2;
    let newPerson3;
    if (sampleAd.profilePhone === sampleAd.Phone) {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
    } else {
      newPerson2 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.profilePhone,
        countryCode: sampleAd?.countryCode,
      };
      newPerson3 = {
        email: sampleAd?.Email,
        phoneNumber: sampleAd?.Phone,
        countryCode: sampleAd?.countryCode,
      };
    }
    serviceInfo.unshift(newPerson1);
    serviceInfo.push(newPerson2);
    if (newPerson3) serviceInfo.push(newPerson3);
    const stringifiedAdditionalPeople = JSON.stringify(serviceInfo);
    let formData = {
      email: !islogin ? vTName : user?.Email,
      phoneNumber: !islogin ? vTNumber : user?.Phone,
      countryCode: !islogin ? selectedCountry : user?.CountryCode,
      phoneDetails: stringifiedAdditionalPeople,
      similarLocalVendor: sampleAd?.similarLocalVendor,
      customerName: `${user?.FirstName} ${user?.LastName}`,
      serviceId: sampleAd?.Id,
      customerId: user?.UserID,
    };
    const response = await makeCall(formData);
    toast.success(
      "Calling the Vendor now, Please Standby as we attempt to get them on the call"
    );
    if (response === "initiating call") {
      const formData = {
        startTime: formatDate(new Date()),
        needName: sampleAd?.listName,
      };
      const linkResponse = await GetZoomLink(formData, sampleAd?.Id);
      dispatch(setLink(linkResponse.join_url));
      let formData1 = {
        zoomlink: linkResponse.join_url,
        phoneDetails: stringifiedAdditionalPeople,
        customerId: user?.UserID,
        ownerId: parseInt(sampleAd?.createdBy),
        Type: "details",
        postId: sampleAd?.Id,
        postName: sampleAd?.listName,
      };
      await sendMsgMail(formData1);
      dispatch(setIsZoomStarted(true));
      await virtualTourClick(sampleAd?.Id);
    } else {
      throw new Error("Response from makeCall was invalid");
    }
  };
  const handleSendOtp = async () => {
    const { axiosClient, toast } = await loadUtilities();
    if (isLoading) return;
    setIsLoading(true);
    try {
      const userData = {
        email: formData.Email,
        Phone: formData.Phone,
        country_code: selectedCountry,
        action: "SIGNUP",
      };
      const response = await axiosClient.post("otp/SendOtp", userData);
      console.log("Send OTP response:", response.data);
      if (response.data.statusCode === 200 && response.data.data?.otp) {
        setReceivedOtp(String(response.data.data.otp));
        toast.success(`Code sent to Phone ${formData.Phone}`);
        dispatch(setEnquiryStep(5));
      } else {
        console.error("Invalid OTP response:", response.data);
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error during OTP sending:", error);
      toast.error("Error sending OTP");
    } finally {
      setIsLoading(false);
    }
  };
  const handleSignup = async () => {
    try {
      const response = await axiosClient.post(
        "auth/register",
        {
          UserName: formData?.Email.split("@")[0].trim(),
          Email: formData?.Email,
          Phone: formData?.Phone,
          RoleID: 2,
          CountryCode: selectedCountry,
          Password: formData?.Email.split("@")[0].trim() + "123",
        },
        {
          validateStatus: (status) => status >= 200 && status < 500,
        }
      );
      if (
        response.data.statusCode === 200 ||
        response.data.statusCode === 404
      ) {
        let userData;
        if (response.data.statusCode === 200) {
          userData = response.data.user; // new user
        } else if (response.data.statusCode === 404) {
          userData = response.data.Data; // existing user
        }
        if (userData) {
          setSignUpData(userData); // still store in state if needed elsewhere
          return userData; // ← IMPORTANT: return the user object
        }
      }
      // Any other status = real failure
      toast.error(response.data.message || "Registration failed");
      return null;
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Network error. Please try again.");
      return null;
    }
  };
  const handleVerifyOtp = async (e) => {
    const { toast } = await loadUtilities();
    e.preventDefault();
    if (!otp || otp.length !== 4) {
      setOtpError(true);
      toast.error("Please enter a 4-digit OTP");
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    try {
      // if (otp === receivedOtp || otp === "9999") {
      if (otp === receivedOtp) {
        toast.success("OTP verified successfully");
        let userId = user?.UserID || null;
        let fullName = islogin
          ? `${user?.FirstName} ${user?.LastName || ""}`
          : formData?.Email.split("@")[0].trim();
        let createdEmail = user?.Email || formData?.Email;
        try {
          if (signUpData) {
            dispatch(
              userAction.setLoginInfo({
                // token: response.data.token,
                userInfo: signUpData,
              })
            );
            localStorage.setItem("USER_ROLE", signUpData?.Role);
            userId = signUpData?.UserID;
            fullName = `${signUpData.FirstName} ${signUpData.LastName || ""}`;
            createdEmail = signUpData.Email;
            if (signUpData?.Role != "customer") {
              toast.error("Please login as a customer to proceed");
              dispatch(setInquiryOpen(false));
              actionRequired(userId);
              return;
            }
          }
        } catch (error) {
          console.error("Error during login:", error);
          toast.error("Error during login");
          return;
        }
        const params = {
          ...formData,
          Title:
            (sampleAd?.Title ||
              sampleAd?.listName ||
              sampleAd?.image_title ||
              bwvSearchQuery ||
              searchQuery ||
              "") + " (Auto Generated)",
          categoryId: sampleAd?.categoryId || null,
          subCategoryId: sampleAd?.subCategoryId || null,
          itemId: sampleAd?.itemId || null,
          needType: sampleAd ? 1 : null,
          createdBy: userId,
          FullName: fullName,
          createdEmail: createdEmail,
          enquiryStep: 4,
          serviceId: formData.serviceId && String(formData.serviceId),
          vendorId: Number(sampleAd?.createdBy),
        };
        // let needExists = false;
        // if (islogin || userId) {
        //   const checkForm = {
        //     Title: params.Title,
        //     userId: userId,
        //   };
        //   const result = await dispatch(checkExisting(checkForm)).unwrap();
        //   needExists = result.data;
        // }
        // if (needExists) {
          // if (actionType === "FROMLINK") {
          //   removeFbclidFromUrl();
          // }
          actionRequired(userId);
          dispatch(setGeneratedNeedId(sampleAd?.Id));
          dispatch(setInquiryOpen(false));
          reset();
          removeFbclidFromUrl();
          // return;
        // }
        dispatch(SendInquiry(params));
        await proceedResults();
      } else {
        setOtpError(true);
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error("Error during OTP verification:", error);
      setOtpError(true);
      toast.error("Error verifying OTP");
    } finally {
      setIsLoading(false);
    }
  };
  const debouncedSetOtp = debounce((value) => {
    setOtp(value);
    console.log("Debounced OTP set:", value);
  }, 100);
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    console.log("Raw input value:", value);
    debouncedSetOtp(value);
    setOtpError(false);
  };
  useEffect(() => {
    if (otp.length === 4) {
      handleVerifyOtp({ preventDefault: () => {} });
    }
  }, [otp]);
  const MessageSend = async (
    parent,
    userId,
    fullName,
    createdEmail,
    userRole
  ) => {
    const description =
      !sampleAd?.Questions &&
      Object.keys(answers || {}).length === 0 &&
      !formData?.eventDetails
        ? formData?.Description || ""
        : (formData?.Description || "") +
          (sampleAd?.Questions && Object.keys(answers || {}).length > 0
            ? "<br/>" +
              Object.entries(answers)
                .map(([label, answer], index) => {
                  try {
                    const parsedQuestions = JSON.parse(sampleAd.Questions);
                    const question = parsedQuestions.find(
                      (q) => q.label === label
                    );
                    if (!question) return "";
                    return `${index + 1}. <b>${label}</b><br/>${answer}<br/>`;
                  } catch (error) {
                    console.error("Failed to parse sampleAd.Questions:", error);
                    return "";
                  }
                })
                .filter(Boolean)
                .join("")
            : "") +
          (formData?.eventDetails
            ? "<br/><b>Event Details:</b><br/>" +
              (Array.isArray(JSON.parse(formData.eventDetails || "[]")) &&
              JSON.parse(formData.eventDetails || "[]").length > 0
                ? JSON.parse(formData.eventDetails)
                    .map((event, index) => {
                      return (
                        `${index + 1}. ` +
                        `<b>Event Date:</b> ${new Date(
                          event.eventDate
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}<br/>` +
                        `<b>Event Time:</b> ${event.eventTime}<br/>` +
                        `<b>Event Type:</b> ${event.eventType}<br/>` +
                        `<b>Event Location:</b> ${event.eventLocation}<br/>` +
                        `<b>Total Guest Count:</b> ${event.totalGuestCount}<br/>`
                      );
                    })
                    .join("<br/>")
                : "")
            : "") +
          (otherVendors.length > 0
            ? "<br/><b>Other Vendors Needed:</b><br/>" +
              otherVendors
                .map((vendor, index) => `${index + 1}. ${vendor}<br/>`)
                .join("")
            : formData.noOtherVendors
            ? "<br/><b>Other Vendors Needed:</b> None<br/>"
            : "") +
          (actionType === "FROMLINK" &&
            `<b>Customer arrived via the "Hyper Link<b/>" <br/>` +
              `<img src="${
                sampleAd.Photo ? JSON.parse(sampleAd.Photo)[0] : ""
              }"/>`);
    const messageForm = {
      customerId: sampleAd?.createdBy || "0",
      postId: sampleAd?.Id || "0",
      postType: 1,
      Description: description,
      messageStatus: 8,
      createdBy: userId, // Use updated userId
      roleId: userRole, // Use role from login response if needed
      ownerId: sampleAd?.createdBy || "0",
      userName: fullName, // Use first name from fullName
      Email: createdEmail,
      serviceNeed: "service",
      parentId: !selectedConvo
        ? parent
          ? parent.Id
          : 0
        : selectedConvo.parentId === 0
        ? selectedConvo.Id
        : selectedConvo.parentId ?? 0,
    };
    try {
      const response = await sendMessage(messageForm);
      if (response) {
        sendNewMessage(response.Data);
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      throw error;
    }
  };
  const reset = () => {
    dispatch(setDescription(""));
    dispatch(resetInquiryState());
    // setDescriptionError(false);
    setEventDetailsError(false);
    setEmailError(false);
    setPhoneError(false);
    setSecondaryPhoneError(false);
    setZipcodeError(false);
    setCountryCodeError(false);
    setOtpError(false);
    setMandatoryQuestionsError(false);
    setOtherVendorsError(false);
    dispatch(setActionType(null));
    dispatch(setEnquiryStep(1));
  };
  const actionRequired = async (userId) => {
    if (actionType === "FROMLINK") {
      // handlenavFromLink();
      removeFbclidFromUrl();
    } else if (actionType === "CALL") {
      dispatch(setShowCallDialog(true));
    } else if (actionType === "TEXT") {
      dispatch(setIsChatModalOpen(true));
    } else if (actionType === "VISIT") {
      window.open(sampleAd.websiteLink, "_blank");
    } else if (actionType === "HIRE") {
      dispatch(setIsModalOpen(true));
      dispatch(setActionType(null));
    } else if (actionType === "VIRTUAL") {
      dispatch(setDropdownOpen(!dropdownOpen));
    } else if (actionType === "VIRTUAL_POP" || actionType === "VIDEO") {
      if (islogin || userId) {
        await handleStartZoomCall();
      }
    }
  };
  const proceedResults = async () => {
    dispatch(setInquiryOpen(false));
    // Initialize userId and userData for logged-in or newly logged-in users
    let userId = user?.UserID || null;
    let fullName = islogin
      ? `${user?.FirstName} ${user?.LastName || ""}`
      : formData?.Email.split("@")[0].trim();
    let createdEmail = user?.Email || formData?.Email;
    let userRole = islogin ? user?.RoleId : 2;
    actionRequired(userId);
    toast.success(
      `Inquiry sent successfully for ${
        sampleAd?.Title || sampleAd?.listName || ""
      }`
    );
    if (isProd && window.dataLayer) {
      window.dataLayer.push({
        event: "inquiry_sent",
        method: "inquiry_submission",
        ad_id: sampleAd?.id || sampleAd?.Id,
      });
    }
    if (sampleAd?.createdBy) {
      const req = {
        customerId: +sampleAd?.createdBy,
        needId: sampleAd?.Id || sampleAd?.id,
        createdBy: userId, // Use updated userId
      };
      const response = await getAllMessages(req);
      const filterParent = response.filter((msg) => msg.parentId == 0);
      await MessageSend(
        filterParent[0],
        userId,
        fullName,
        createdEmail,
        userRole
      );
    }
    dispatch(setGeneratedNeedId(sampleAd?.Id));
    dispatch(setInquiryOpen(false));
    dispatch(resetInquiryState());
    removeFbclidFromUrl();
    reset();
    setGuestUserData(null);
  };
  const handleBack = () => {
    dispatch(setEnquiryStep(1));
    setOtp("");
    setOtpError(false);
  };
  if (isAdmin || isVendor) return null;
  const removeFbclidFromUrl = () => {
    const url = new URL(window.location.href);
    if (url.searchParams.has("fbclid")) {
      url.searchParams.delete("fbclid");
      window.history.replaceState({}, document.title, url.toString());
    }
  };
  const handleStep = async () => {
    if (!validateForm()) return;
    if (isLoading) return;
    setIsLoading(true);
    try {
      let currentUserId = user?.UserID || guestUserData?.UserID || null;
      let currentFullName = user?.FirstName
        ? `${user.FirstName} ${user.LastName || ""}`.trim()
        : guestUserData
        ? `${guestUserData.FirstName} ${guestUserData.LastName || ""}`.trim()
        : formData?.Email.split("@")[0].trim();
      let currentEmail = user?.Email || guestUserData?.Email || formData?.Email;
      if (!islogin && enquiryStep === 1 && !guestUserData) {
        const registeredUser = await handleSignup();
        if (!registeredUser?.UserID) {
          toast.error("Registration failed. Please try again.");
          setIsLoading(false);
          return;
        }
        setGuestUserData(registeredUser);
        currentUserId = registeredUser.UserID;
        currentFullName = `${registeredUser.FirstName} ${
          registeredUser.LastName || ""
        }`.trim();
        currentEmail = registeredUser.Email;
      }
      const params = {
        ...formData,
        countryCode: selectedCountry,
        Title:
          (sampleAd?.Title ||
            sampleAd?.listName ||
            sampleAd?.image_title ||
            bwvSearchQuery ||
            searchQuery ||
            "") + " (Auto Generated)",
        categoryId: sampleAd?.categoryId || null,
        subCategoryId: sampleAd?.subCategoryId || null,
        itemId: sampleAd?.itemId || null,
        subCategoryId: sampleAd?.subCategoryId || null,
        itemId: sampleAd?.itemId || null,
        needType: sampleAd ? 1 : null,
        createdBy: currentUserId, // ← now correct in all steps
        createdEmail: currentEmail,
        FullName: currentFullName,
        serviceId: sampleAd?.Id ? String(sampleAd.Id) : null,
        vendorId: sampleAd?.createdBy ? Number(sampleAd?.createdBy) : 0,
      };
      if (enquiryStep === 1) {
        params.enquiryStep = 1;
        await dispatch(SendInquiry(params)).unwrap();
        if (isProd && window.dataLayer) {
          window.dataLayer.push({
            event: "inquiry",
            method: "inquiry_started",
            ad_id: sampleAd?.id || sampleAd?.Id,
          });
        }
        dispatch(setEnquiryStep(2));
      } else if (enquiryStep === 2) {
        params.enquiryStep = 2;
        await dispatch(SendInquiry(params)).unwrap();
        dispatch(setEnquiryStep(3));
      } else if (enquiryStep === 3) {
        params.enquiryStep = 3;
        await dispatch(SendInquiry(params)).unwrap();
        dispatch(setEnquiryStep(4));
      } else if (enquiryStep === 4) {
        if (islogin) {
          params.enquiryStep = 4;
          await dispatch(SendInquiry(params)).unwrap();
          await proceedResults();
        } else {
          params.enquiryStep = 3; // ← usually correct for guest flow
          await dispatch(SendInquiry(params)).unwrap();
          await handleSendOtp();
        }
      }
    } catch (error) {
      console.error("Error submitting inquiry step:", error);
      toast.error(error.message || "Failed to save data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <React.Fragment>
      <Dialog
        open={inquiryOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        PaperProps={{
          style: {
            maxWidth: "400px",
            zIndex: 1085,
          },
        }}
        sx={{ zIndex: 1085 }}
        BackdropProps={{
          onClick: handleBackdropClick,
          style: { zIndex: 1085 },
        }}
      >
        <Button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: 10,
            right: 2,
            zIndex: 1,
          }}
          aria-label="close"
        >
          <FaWindowClose />
        </Button>
        <DialogTitle id="alert-dialog-title" style={{ padding: "4px 12px" }}>
          Send your inquiry to{" "}
          {sampleAd?.listName || sampleAd?.Title || "vendor"}
        </DialogTitle>
        <DialogContent>
          {/* <div className="booking-form__progress">
            <div className="booking-form-progress__wizard">
              {(() => {
                const baseSteps = [
                  { num: 1, label: "Client Info" },
                  { num: 2, label: "Event Details" },
                  { num: 3, label: "Questions & Description" },
                  { num: 4, label: "Other Vendors" },
                ];

                const steps = islogin
                  ? baseSteps
                  : [...baseSteps, { num: 5, label: "OTP Verification" }];

                // Map enquiryStep to visual progress position
                const visualCurrentStep = islogin
                  ? enquiryStep // 1 → 1, 3 → 2, 4 → 3, 5 → 4
                  : enquiryStep; // non-login: 1 to 5 directly

                return steps.map((step, index) => {
                  const isComplete = step.num < visualCurrentStep;
                  const isCurrent = step.num === visualCurrentStep;

                  let className = "progress-wizard__item";
                  if (isComplete)
                    className += " progress-wizard__item--complete";
                  if (isCurrent) className += " progress-wizard__item--current";

                  return (
                    <div key={step.num} className={className}>
                      <div className="progress-wizard-item__step">
                        {index + 1}
                      </div>
                      <div className="progress-wizard-item__label">
                        {step.label}
                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          </div> */}
          <InquiryForm
            islogin={islogin}
            formData={formData}
            dispatch={dispatch}
            firstInputRef={firstInputRef}
            selectedCountry={selectedCountry}
            setSelectedCountry={setSelectedCountry}
            emailError={emailError}
            setEmailError={setEmailError}
            zipcodeError={zipcodeError}
            setZipcodeError={setZipcodeError}
            phoneError={phoneError}
            setPhoneError={setPhoneError}
            secondaryPhoneError={secondaryPhoneError}
            setSecondaryPhoneError={setSecondaryPhoneError}
            countryCodeError={countryCodeError}
            setCountryCodeError={setCountryCodeError}
            // descriptionError={descriptionError}
            // setDescriptionError={setDescriptionError}
            mandatoryQuestionsError={mandatoryQuestionsError}
            setMandatoryQuestionsError={setMandatoryQuestionsError}
            eventDetailsError={eventDetailsError}
            setEventDetailsError={setEventDetailsError}
            otherVendorsError={otherVendorsError}
            setOtherVendorsError={setOtherVendorsError}
            enquiryStep={enquiryStep}
            otp={otp}
            handleOtpChange={handleOtpChange}
            otpError={otpError}
            handleBack={handleBack}
          />
        </DialogContent>
        <DialogActions>
          {/* {enquiryStep != 2 && ( */}
          <Button onClick={handleStep} autoFocus disabled={isLoading}>
            {isLoading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : enquiryStep < 4 || (enquiryStep === 4 && !islogin) ? (
              "Continue"
            ) : (
              `Send Inquiry to ${
                sampleAd?.listName || sampleAd?.Title || "vendor"
              }`
            )}
          </Button>
          {/* )} */}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default InquiryModal;
